(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("imjoyRPCSocketIO", [], factory);
	else if(typeof exports === 'object')
		exports["imjoyRPCSocketIO"] = factory();
	else
		root["imjoyRPCSocketIO"] = factory();
})(this, function() {
return 